<template>
  <div class="phone-links">    
    <a class="phone-links__btn phone-links__btn--call" :href="'tel:' + phone" aria-label="اتصال">
      <svg-icon type="mdi" :path="pathPhone"></svg-icon>
    </a>
    <a class="phone-links__btn phone-links__btn--whatsapp" :href="'https://wa.me/' + phone" aria-label="مراسلة عبر واتساب">
      <svg-icon type="mdi" :path="pathWhatsapp"></svg-icon>
    </a>
    <span class="phone-links__number" dir="ltr">{{ phone }}</span>
  </div>
</template>

<script>
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiPhone, mdiWhatsapp } from "@mdi/js";

// Call and WhatsApp shortcuts followed by the phone number.
export default {
  name: "PhoneLinks",
  components: { SvgIcon },
  props: {
    phone: { type: [String, Number], default: null },
  },
  data() {
    return {
      pathPhone: mdiPhone,
      pathWhatsapp: mdiWhatsapp,
    };
  },
};
</script>
